export const GET_TRANSPORT_USERS_LIST = 'GET_TRANSPORT_USERS_LIST';
export const GET_TRANSPORT_USERS_LIST_SUCCESS = 'GET_TRANSPORT_USERS_LIST_SUCCESS';
export const GET_TRANSPORT_USERS_LIST_FAILURE = 'GET_TRANSPORT_USERS_LIST_FAILURE';



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/constants/get_transport_users_list.constants.js